/* eslint-disable import/prefer-default-export */
import { List } from 'immutable'
import { getAuthIsLoggedIn } from '../auth/index'

/** Whether the client should fetch account profiles (SSR defers this hydrate). */
export function shouldFetchProfilesOnClient (state) {
  const { auth, userProfiles } = state
  if (!getAuthIsLoggedIn(auth)) {
    return false
  }
  if (userProfiles.get('processing')) {
    return false
  }
  const data = userProfiles.get('data', List())
  return !List.isList(data) || data.size === 0
}
